const weightUnitEnum = Object.freeze({
    kg: 0,
    lbs: 1,
    T: 2,
})

export default weightUnitEnum